import React, { useState } from 'react';

import { withSnackbar } from 'notistack';
import appConstants from '../../../appConstants';
import Filters from './CategoryFilter';
import GridsContainer from './grid';
import useForecastData from './useForecastData';
import { getDefaultValueForFilters, includeCombinedData } from './util';

const filterOptions = [
  {
    label: 'All',
    value: 0,
    filter: 'all'
  },
  {
    label: 'Agent Deliveries',
    value: 1,
    filter: 'agent'
  },
  {
    label: 'Guaranteed Shipments',
    value: 2,
    filter: 'guaranteedShipments'
  },
  {
    label: 'White Glove Shipments',
    value: 3,
    filter: 'whiteGloveShipments'
  },
];

const initialDataValue = getDefaultValueForFilters(filterOptions);

const NetworkView = ({ enqueueSnackbar, quickFilter }) => {
  const [selectedFilter, setSelectedFilter] = useState(filterOptions[0]);
  const headerId ="NetworkView";
  const showErrorMessage = (dataField) => {
    enqueueSnackbar(`Error while fetching ${dataField} for network`, { variant: 'error' });
  };

  const { customers, bills, refreshData, isCustomersLoading, isBillsLoading } = useForecastData({
    defaultValue: initialDataValue,
    customerAPI: 'GetCustomersForNetworkForecast',
    billsAPI: 'GetShipmentForecastForNetwork',
    queryString: '',
    showErrorMessage,
    headerId,
    responseDataModifier: includeCombinedData
  });

  const onChange = (filter) => {
    setSelectedFilter(filter);
  };

  const filteredCustomers = customers[selectedFilter.filter] ?? [];
  const filteredBills = bills[selectedFilter.filter] ?? [];

  return (
    <>
      <Filters
        onChange={onChange}
        filterOptions={filterOptions}
        handleRefreshClick={refreshData}
        headerId={headerId}
      />
      <GridsContainer
        activeFilter={selectedFilter.filter}
        quickFilter={quickFilter}
        customers={{
          gridName: appConstants.gridNames.shipmentForecastNetworkCustomers,
          data: filteredCustomers
        }}
        bills={{
          gridName: appConstants.gridNames.shipmentForecastNetworkBills,
          data: filteredBills
        }}
        isCustomersLoading={isCustomersLoading}
        isBillsLoading={isBillsLoading}
      />
    </>
  );
};

export default withSnackbar(NetworkView);
